import styled from 'styled-components';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { SELECTABLE_BOX_SHADOW_COLOR } from 'HubStyleTokens/theme';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import Small from 'UIComponents/elements/Small';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIImage from 'UIComponents/image/UIImage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIBreakString from 'UIComponents/text/UIBreakString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import CertifiedBadge from 'marketplace-ui-common/components/CertifiedBadge';
// @ts-expect-error its a JS file
import AppCardInstalls from './AppCardInstalls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUICardWrapper = styled(UICardWrapper).withConfig({
  displayName: "AppCard__StyledUICardWrapper",
  componentId: "rg6l4i-0"
})(["border:2px solid transparent;transition:border ", " ease-out;&:hover{border-color:", ";box-shadow:0 0 12px 0 ", ";}"], MICRO_TRANSITION_TIMING, CALYPSO_MEDIUM, SELECTABLE_BOX_SHADOW_COLOR);
export default function AppCard({
  certified,
  className,
  companyName,
  hasRecommendedBadge,
  hubInstalls,
  iconUrl,
  installed = false,
  installsCount,
  name,
  showIsNewApp = false,
  tagline = ''
}) {
  return /*#__PURE__*/_jsxs(StyledUICardWrapper, {
    className: className,
    compact: true,
    children: [/*#__PURE__*/_jsxs(UICardSection, {
      children: [hasRecommendedBadge && /*#__PURE__*/_jsx(UIBadge, {
        className: "m-bottom-4",
        use: "thunderdome",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.cards.appCard.recommended"
        })
      }), /*#__PURE__*/_jsxs(UIMediaObject, {
        itemLeft: /*#__PURE__*/_jsx(UIImage, {
          src: iconUrl,
          style: {
            maxHeight: 48
          }
        }),
        spacing: "medium",
        children: [/*#__PURE__*/_jsx(UIBreakString, {
          className: "is--heading-4 m-bottom-0",
          children: name
        }), /*#__PURE__*/_jsx(UIBreakString, {
          children: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystemMarketplaceCore.cards.appCard.companyName",
              options: {
                companyName
              }
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(UICardSection, {
      scrollable: true,
      children: tagline
    }), /*#__PURE__*/_jsxs(UICardSection, {
      className: "align-end justify-between",
      children: [/*#__PURE__*/_jsx(AppCardInstalls, {
        installed: installed,
        installsCount: installsCount != null ? installsCount : hubInstalls,
        showIsNewApp: showIsNewApp
      }), certified && /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.cards.appCard.hubspotCertified"
        }),
        children: /*#__PURE__*/_jsx(CertifiedBadge, {})
      })]
    })]
  });
}